const QA = {
  ibanLength: 29,
};
export { QA };
